import { createAuthService } from '@/libs/device-auth/services/authService';
import { storageSvc } from './storageServiceClient';
import { DefaultAuthConfig } from './authConfig';
import { apiClient } from './apiClient';
import { SsoUserInfoClient } from './ssoUserInfoClient';

const authConfig = new DefaultAuthConfig();

export const authServiceInstance = createAuthService(
  storageSvc, // AuthStorage (now includes security methods)
  authConfig,
  apiClient,
  new SsoUserInfoClient(`https://sso.${authConfig.domain}/api/v1`),
);
